import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-classification',
  templateUrl: './classification.component.html'
})
export class ClassificationComponent implements OnInit {

  labelButtonBack = '';
  idDetails = 0;

  constructor(private translate: TranslateService) {
  }

  ngOnInit() {
    this.translate.get([
      'common.back'
    ]).subscribe((res) => {
      this.labelButtonBack = res['common.back'];
    });
  }

  togleClassificationList (row) {
    if (this.idDetails === 0) {
      this.idDetails = row.id;
      console.log(this.idDetails);
    } else {
      this.idDetails = 0;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/classification/classification.component.ts